<button *ngIf="!processing" mat-icon-button [disabled]="processing" (click)="refresh()">
  <mat-icon>refresh</mat-icon>
</button>
<div *ngIf="processing" style="margin:5px 10px 9px 10px;padding-top:6px">
  <mat-progress-spinner [diameter]="20" mode="indeterminate"></mat-progress-spinner>
</div>

